/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated';
import { divideDependencies } from './dependenciesDivide.generated';
import { factorialDependencies } from './dependenciesFactorial.generated';
import { isIntegerDependencies } from './dependenciesIsInteger.generated';
import { isPositiveDependencies } from './dependenciesIsPositive.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createMultinomial } from '../../factoriesAny.js';
export var multinomialDependencies = {
  addDependencies: addDependencies,
  divideDependencies: divideDependencies,
  factorialDependencies: factorialDependencies,
  isIntegerDependencies: isIntegerDependencies,
  isPositiveDependencies: isPositiveDependencies,
  multiplyDependencies: multiplyDependencies,
  typedDependencies: typedDependencies,
  createMultinomial: createMultinomial
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMultinomial.generated.js
// module id = 1462
// module chunks = 0